import { Link } from 'react-router-dom';
import { siteConfig } from '@/mocks/site';

export default function Hero() {
  return (
    <section className="relative w-full overflow-hidden bg-foreground-950">
      <div className="absolute inset-0 h-full w-full">
        <img
          src="https://readdy.ai/api/search-image?query=abstract%20dark%20moody%20texture%20of%20folded%20paper%20documents%20and%20a%20map%20with%20film%20grain%2C%20deep%20brown%20and%20amber%20tones%2C%20cinematic%20editorial%20background%2C%20no%20text%2C%20high%20detail&width=1600&height=900&seq=mb-hero-01&orientation=landscape"
          alt="跨境诈骗内幕档案背景，泛黄的地图与卷宗纸张"
          title="缅北黑料反诈内幕档案 - 诈骗园区与电诈内幕"
          className="h-full w-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/60 to-black/75"></div>

      <div className="relative mx-auto flex w-full max-w-content flex-col justify-center px-4 py-20 md:px-6 md:py-28 lg:py-32">
        <span className="inline-flex w-fit items-center gap-2 rounded-full border border-accent-400/60 bg-accent-500/15 px-4 py-1.5 text-xs font-medium tracking-wide text-accent-200">
          <i className="ri-alert-line" aria-hidden="true"></i>
          跨境风险提示 · 内容持续更新
        </span>

        <h1 className="mt-6 max-w-3xl font-heading text-3xl font-black leading-[1.2] text-background-50 md:text-5xl lg:text-[3.4rem]">
          {siteConfig.name}
          <span className="mt-2 block text-xl font-bold text-primary-300 md:text-2xl lg:text-3xl">
            反诈内幕档案库
          </span>
        </h1>

        <p className="mt-6 max-w-2xl text-sm leading-relaxed text-background-200 md:text-base">
          聚合缅北诈骗园区、电诈窝点、虚假投资与高薪招聘骗局的深挖内容，提供受害者经历与园区运作线索，帮你认清骗局套路，远离跨境陷阱。
        </p>

        <div className="mt-9 flex flex-col gap-3 sm:flex-row">
          <Link
            to="/archives"
            className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-7 py-3.5 text-sm font-medium text-background-50 transition-colors hover:bg-accent-600"
          >
            <i className="ri-book-read-line" aria-hidden="true"></i>
            浏览全部档案
          </Link>
          <Link
            to="/faq"
            className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-100/40 px-7 py-3.5 text-sm font-medium text-background-50 transition-colors hover:bg-background-50/10"
          >
            <i className="ri-question-line" aria-hidden="true"></i>
            我是不是遇到骗局了
          </Link>
        </div>

        <dl className="mt-14 grid grid-cols-2 gap-6 border-t border-background-100/20 pt-8 md:grid-cols-4">
          {[
            { k: '已整理档案', v: '28+' },
            { k: '骗局类型', v: '4 类' },
            { k: '平均被困', v: '47 天' },
            { k: '出境自检项', v: '9 项' },
          ].map((item) => (
            <div key={item.k}>
              <dt className="text-xs tracking-wide text-background-300">{item.k}</dt>
              <dd className="mt-1 font-heading text-2xl font-bold text-background-50">{item.v}</dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}